<template>
    <b-card>
        <b-card-header>
            <h3>Överlagrad statistik</h3>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col cols="12">
                    <b-card>
                        <b-card-title>Lägg till</b-card-title>
                        <b-card-body>
                            <b-row v-if="errMsgs && errMsgs.length > 0">
                                <b-col cols="12">
                                    <b-alert variant="danger" show>
                                        <li v-for="(e, i) in errMsgs" :key="i">{{ e }}</li>
                                    </b-alert>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2">Terminal:</b-col>
                                <b-col cols="3">
                                    <b-form-select v-model="selTerminal" :options="terminals">
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>Välj
                                                terminal...</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2">
                                    Datum:
                                </b-col>
                                <b-col cols="3">
                                    <datepicker v-model="selDate" :stepper="true">
                                    </datepicker>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2">
                                    Otif Åkeri:
                                </b-col>
                                <b-col cols="3">
                                    <b-form-input v-model="selCrOtif"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="2">
                                    Otif Kund:
                                </b-col>
                                <b-col cols="3">
                                    <b-form-input v-model="selOtif"></b-form-input>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col cols="2">
                                    <b-button @click="add">+ Lägg till</b-button>
                                </b-col>
                                <b-col cols="2">
                                    <b-button variant="light" @click="clearForm"><b-icon-x-circle></b-icon-x-circle> Rensa
                                        formulär</b-button>
                                </b-col>

                            </b-row>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b>Leveransdag</b>
                </b-col>
                <b-col>
                    <b>Terminal</b>
                </b-col>
                <b-col>
                    <b>OTIF Åkeri (%)</b>
                </b-col>
                <b-col>
                    <b>OTIF Kund (%)</b>
                </b-col>
                <b-col></b-col>
            </b-row>
            <b-row v-for="(o, i) in list" :key="i">
                <b-col>
                    {{ o.StopRefDate }}
                </b-col>
                <b-col>
                    {{ o.TerminalName }}
                </b-col>
                <b-col>
                    {{ o.CrAvgOnTimeHour }}
                </b-col>
                <b-col>
                    {{ o.AvgOnTimeHour }}
                </b-col>
                <b-col>
                    <b-button variant="light" size="sm" title="Ta bort"
                        @click="deleteOvr(i)"><b-icon-x-circle></b-icon-x-circle></b-button>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import datepicker from "../../components/datepicker";

import { Api } from "../../lib/api";
const api = new Api();

export default {
    name: 'StatPerDayOverride',
    components: { datepicker },
    data() {
        return {
            list: null,
            terminals: null,
            selTerminal: null,
            selDate: null,
            selCrOtif: null,
            selOtif: null,
            errMsgs: null,
        }
    },
    created() {
        api.get("/api/Booking/GetTerminals").then((res) => {
            this.terminals = [];
            res.data.sort((a,b)=> a.terminalName > b.terminalName? 1:-1).map(x => {
                this.terminals.push({ text: x.terminalName, value: x.terminalName });
            });
        });
        this.getData();
    },
    methods: {
        getData() {
            api.get('/api/stat/GetOverrides?maxCount=100').then(res => {
                this.list = res.data;
            });
        },
        add() {
            this.validate();
            if (this.errMsgs.length > 0)
                return;

            let dt = String(this.selDate).replaceAll('-', '');
            var p = {
                TerminalName: this.selTerminal,
                StopRefDate: dt,
                AvgOnTimeHour: this.selOtif,
                CrAvgOnTimeHour: this.selCrOtif,
                AvgInFull: 100,
                CrAvgInFull: 100,
            };
            api.post('/api/stat/SetOverride', p).then(res => {
                this.getData();

                if (res.data) {
                    alert(res.data);
                }
                else {
                    this.clearForm();
                }
            });
        },
        deleteOvr(i) {
            var o = this.list[i];
            var terminalName = o.TerminalName;
            var dt = o.StopRefDate;
            if (confirm(`Ta bort överlagring för ${terminalName} den ${dt}?`)) {
                api.delete(`/api/stat/DeleteOverride?stopRefDate=${dt}&terminalName=${terminalName}`).then(res => {
                    this.getData();

                    if (res.data) {
                        alert(res.data);
                    }
                    else {
                        //Set removed value
                        this.selTerminal = terminalName;
                        this.selDate = dt;
                        this.selOtif = o.AvgOnTimeHour;
                        this.selCrOtif = o.CrAvgOnTimeHour;
                    
                    }
                })
            }
        },
        validate() {
            let res = [];

            if (!this.selTerminal)
                res.push('Terminal måste anges');
            if (!this.selDate)
                res.push('Datum måste anges');
            if (!this.selCrOtif || this.selCrOtif > 100)
                res.push('Otif åkeri ej korrekt.');
            if (!this.selOtif || this.selOtif > 100)
                res.push('Otif kund ej korrekt.');

            this.errMsgs = res;
        },
        clearForm() {
            this.selCrOtif = null;
            this.selOtif = null;
            this.errMsgs = null;
        }

    }

}

</script>